import Observation from '~/scripts/services/model/observation';
import angular from 'angular';
import filePreviewModal from '~/components/ktable/modals/file-preview/file-preview-modal.component';
import Utils from '~/scripts/services/utils';

export default class WfObservationsController {
	/* @ngInject */
	/**
	 * @param {import('angular').auto.IInjectorService} $injector
	 * @param {import('~/components/download/download.service').FileDownloadServiceModel} FileDownloadService
	 */
	constructor(
		$injector,
		FileDownloadService,
	) {
		this.$injector = $injector;
		this.FileDownloadService = FileDownloadService;
		this.$timeout = $injector.get('$timeout');
		this.$uibModal = $injector.get('$uibModal');

		/** @type {{headerTitle: boolean, minFiles: number, maxFiles: number}} */
		this.defaultOptions = {
			headerTitle: true,
			minFiles:    0,
			maxFiles:    100,
		};

		this.disabled = false;

		/** @type {any} */
		this.fileParams = {};

		/** @type {Observation[]} */
		this.observations = [];

		/** @type {{headerTitle: boolean, minFiles: number, maxFiles: number}} */
		this.options = { ...this.defaultOptions };
	}

	/**
	 * @param {File[]|FileList[]} files
	 */
	add(files) {
		if (!this.disabled) {
			for (const file of files) {
				if (file instanceof FileList) {
					Array.prototype.forEach.call(file, item => {
						const observation = new Observation(this.$injector, item);
						observation.edit = false;
						observation.previousValues = {
							name:    '',
							comment: '',
						};
						this.$timeout(() => {
							this.observations.push(observation);
						});
					});
				}
				else {
					/** @type {Observation} */
					// @ts-ignore
					const observation = new Observation(this.$injector, file);
					observation.edit = false;
					observation.previousValues = {
						name:    '',
						comment: '',
					};
					this.$timeout(() => {
						this.observations.push(observation);
					});
				}
			}
		}
	}

	/**
	 * @param {Observation} observation
	 */
	cancel(observation) {
		observation.name = observation.previousValues.name;
		observation.comment = observation.previousValues.comment;
		observation.edit = false;
	}

	/**
	 * @param {Observation} observation
	 */
	edit(observation) {
		if (!this.disabled) {
			this.observations.map(o => ({ ...o, edit: false }));
			observation.edit = true;
			this.$timeout(() => {
				const $inputRename = angular.element('.wf > form input.edit-observation');
				observation.previousValues.name = observation.name ?? '';
				observation.previousValues.comment = observation.comment ?? '';

				$inputRename
					.trigger('focus')
					.on('keypress blur', /** @type {import('jquery').Event} */event => {
						if (event.key === 'Enter') {
							event.preventDefault();
							this.$timeout(() => {
								observation.edit = false;
							});
						}
						else if (event.key === 'Escape') {
							event.preventDefault();
							this.$timeout(() => {
								observation.edit = false;
								observation.comment = observation.previousValues.comment;
								observation.name = observation.previousValues.name;
							});
						}
					});
			});
		}
	}

	/**
	 * @param {Observation} observation
	 */
	async preview(observation) {
		if (observation.file.mimetype === 'application/pdf') {
			await this.$uibModal.open({
				...filePreviewModal({
					resolve: {
						kid: () => observation.kid,
					},
				}),
				size: 'full',
			}).result;
		}
		else {
			const result = await this.FileDownloadService.download([{ kid: observation.kid }]);
			if (result) {
				Utils.download(result.data, result.data.type, result.name);
			}
		}
	}

	$onInit() {
		this.options = {
			...this.defaultOptions,
			...this.options,
		};

		this.fileParams = { maxFiles: this.options.maxFiles };
	}
}
